export const SEARCH_LOCATION_PARAMS = 'search_location';
